import { Guid } from '@fitscovery/common/types';
import { FitnessConsumerProfile, User } from '@fitscovery/user/data-access';

export namespace UserActions {

  export class GetCurrentUser {
    static readonly type = '[User] GetCurrentUser';
    constructor() { }
  }

  export class GetUserPartners {
    static readonly type = '[User] GetUserPartners';
    constructor() { }
  }
  
  export class GetFitnessConsumerProfile {
    static readonly type = '[User] GetFitnessConsumerProfile';
    constructor() { }
  }
  
  export class UpdateFitnessConsumerProfile {
    static readonly type = '[User] UpdateFitnessConsumerProfile';
    constructor(public profile: FitnessConsumerProfile) { }
  }

}
